import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';

import { clientNameSelector } from 'store/modules/auth';
import { add, cancel, fetchExperiences, messages, clearMam } from '../modules';
import withAuth from 'hoc/withAuth';
import Mam from '../components/Mam';

// old
// const mapStateToProps = createSelector(clientNameSelector, clientName => ({
//   clientName,
// }));

const mapStateToProps = state => {
  return {
    clientName: clientNameSelector(state),
    messages: messages(state),
  };
};

const mapDispatchToProps = dispatch => ({
  fetchExperiences(campaignId) {
    dispatch(fetchExperiences(campaignId));
  },

  add() {
    dispatch(add());
  },

  cancel() {
    dispatch(cancel());
  },

  clearMam() {
    dispatch(clearMam());
  },
});

const $connect = connect(
  mapStateToProps,
  mapDispatchToProps
);

const $lifecycle = lifecycle({
  componentDidMount() {
    const { id } = this.props.match.params;
    this.props.fetchExperiences(id);
  },
  componentWillUnmount() {
    this.props.clearMam();
  },
});

const enhance = compose(
  $connect,
  $lifecycle,
  withAuth
);

export default enhance(Mam);
